import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import NavLinks from '../Navbar/NavLinks';
import logo from '../../images/logo.png';
import { Close, LoginOutlined, MenuOpen } from '@mui/icons-material';
import { useSelector } from 'react-redux';

const NavBar = () => {
  const [top, setTop] = useState(!window.scrollY);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
const { token, isEmailVerified, isContactVerified } = useSelector((state) => state.qps);
const isLoggedIn = Boolean(token) && isEmailVerified && isContactVerified;
  const handleClick = () => setIsOpen(!isOpen);

  useEffect(() => {
    const scrollHandler = () => {
      setTop(window.pageYOffset <= 10);
    };
    window.addEventListener('scroll', scrollHandler);
    return () => window.removeEventListener('scroll', scrollHandler);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 w-full z-30 transition duration-300 ease-in-out ${
        !top ? 'bg-white shadow-lg' : ''
      }`}
    >
     <div className="max-w-7xl mx-auto flex justify-between items-center py-2 px-4 lg:px-8">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <img
            src={logo}
            alt="QUADPROSOFT"
              className="w-[120px] sm:w-[140px] md:w-[155px] lg:w-[170px] h-auto object-contain"
          />
        </Link>

        {/* Mobile Menu Button */}
        <div className="lg:hidden relative z-50">
          <button
            className="p-2 rounded-lg text-blue-900 flex items-center justify-center"
            onClick={handleClick}
          >
            {isOpen ? (
              <Close className="h-7 w-7 md:h-8 md:w-8" />
            ) : (
              <MenuOpen className="h-7 w-7 md:h-8 md:w-8" />
            )}
          </button>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden lg:flex items-center space-x-6">
          <NavLinks />
           {/* Login */}
         
          <a
  href="https://payment.quadprosoft.com/#/"
  target="_blank"
  rel="noopener noreferrer"
  className="group flex items-center gap-2 transition-all duration-300 hover:scale-110"
>
  <LoginOutlined className="text-[#153E75] transition-all duration-300 group-hover:text-[#1E88E5]" />
  <span className="text-[#153E75] font-medium text-sm md:text-base lg:text-lg transition-all duration-300 group-hover:text-[#1E88E5]">
    Login
  </span>
</a>
        

          {/* Contact Button */}
          <Link
  to="/contact"
  className="px-6 py-3 rounded-xl bg-[#153E75] hover:bg-[#1E88E5] text-white shadow-xl transition-all duration-300 hover:scale-105 text-base font-medium"
>
  Contact Us
</Link>

         
         
        </div>

        {/* Mobile Navigation */}
        <div
          className={`fixed left-0 w-full bg-white shadow-xl p-6 transition-all duration-300
          flex flex-col items-center space-y-4 lg:hidden
          ${isOpen ? 'top-14 opacity-100' : '-top-full opacity-0'}`}
        >
          <NavLinks />

          {/* Contact Button */}
          <Link
            to="/contact"
            className="px-6 py-3 rounded-xl bg-blue-900 hover:bg-blue-800 text-white shadow-xl
                       text-base font-medium"
          >
            Contact Us
          </Link>

          {/* Login */}
          <a
  href="https://payment.quadprosoft.com/#/"
  target="_blank"
  rel="noopener noreferrer"
  className="group flex items-center gap-2 transition-all duration-300 hover:scale-110"
>
  <LoginOutlined className="text-[#153E75] transition-all duration-300 group-hover:text-[#1E88E5]" />
  <span className="text-[#153E75] font-medium text-base transition-all duration-300 group-hover:text-[#1E88E5]">
    Login
  </span>
</a>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
